// Mirrors @netzportal/domain/commissioning/systemChange (#25137).
export function isCommissioningSystemChange(payload) {
  return (
    payload?.order_type === 'zaehlerwechsel' &&
    (payload.measure_reason?.code === 'WAÄ' ||
      payload.measure_reason?.label === 'Anlagenänderung')
  );
}

// Since #25137 WAÄ orders collect the meter sizing details: appliances for Gas/Strom, usage types for Wasser.
// WAÄ orders submitted before carry counter data only and keep the classic Zählerwechsel handling.
export function hasCommissioningSystemChangeDetails(payload) {
  return (
    isCommissioningSystemChange(payload) &&
    (hasEntries(payload.usage_types) || hasEntries(payload.power_appliances))
  );
}

function hasEntries(value) {
  return Array.isArray(value) && value.length > 0;
}

export function usesCommissioningInstallationDetails(payload) {
  return (
    payload?.order_type === 'zaehlereinbau' ||
    hasCommissioningSystemChangeDetails(payload)
  );
}

const LEGACY_CONNECTION_POWER_PREFIX = 'Anlagenänderung: ';

// Legacy WAÄ orders store the connection power as order_remark prefix; parsed like the installer portal edit.
export function splitLegacySystemChangeRemark(payload) {
  const orderRemark = payload?.order_remark || '';

  if (
    !isCommissioningSystemChange(payload) ||
    hasCommissioningSystemChangeDetails(payload) ||
    !payload.counter_id?.trim() ||
    !orderRemark.startsWith(LEGACY_CONNECTION_POWER_PREFIX)
  ) {
    return { connectionPower: null, remark: orderRemark || null };
  }

  const [connectionPower, ...remarkParts] = orderRemark
    .slice(LEGACY_CONNECTION_POWER_PREFIX.length)
    .split(',\n');

  return {
    connectionPower: connectionPower.trim() || null,
    remark: remarkParts.join(',\n') || null,
  };
}
